import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Tabs from '../views/Tabs.vue';


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/music/recommended'
  },
  {
    path: '/app',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/music/',
    component: Tabs,
    children: [
      {
        path: '',
        redirect: '/music/recommended',
      },
      {
        path: 'recommended',
        component: () => import('@/views/Tab1.vue'),
        children: [
          {
            path: 'p/:id',
            component: () => import('@/views/PlaylistDetails.vue'),
          }
        ]
      },
      {
        path: 'playlist',
        component: () => import('@/views/Tab2.vue'),
        children: [
          {
            path: 'p/:id',
            component: () => import('@/views/YourPlaylistDetails.vue')
          }
        ]
      },
      {
        path: 'profile',
        component: () => import('@/views/Tab3.vue')
      }
    ]
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
